<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: {
    type:  Object as () => NuxtError,
    default: () => ({
      statusCode: 500,
      statusMessage: 'An unexpected error occurred'
    } as NuxtError)
  }
})
</script>

<template>
  <div class="antialiased bg-white dark:bg-black dark:text-white font-sans grid min-h-screen overflow-hidden place-content-center text-black">
    <div class="-bottom-1/2 fixed h-1/2 left-0 right-0 spotlight" />
    <div class="max-w-520px text-center">
      <h1 class="font-medium mb-8 sm:text-10xl text-8xl">{{ props.error?.statusCode }}</h1>
      <p class="font-light leading-tight mb-16 px-8 sm:px-0 sm:text-4xl text-xl">{{ props.error?.statusMessage }}</p>
    </div>
  </div>
</template>